import { apiClient } from '@/lib/api/client';
function groupStatusToCount(groups, status) {
    return groups.filter(g => g.status === status).length;
}
export const dashboardApi = {
    async getStats(tenantId) {
        const [groupsRes, passengersRes, notifRes] = await Promise.all([
            apiClient.get('/api/v1/groups', {
                params: { page: 1, pageSize: 100 },
            }),
            apiClient.get('/api/v1/passengers', {
                params: { page: 1, pageSize: 100 },
            }),
            apiClient.get('/api/v1/notifications/unread-count'),
        ]);
        const activeGroups = groupsRes.data.data.filter(g => g.status === 'CONFIRMED' || g.status === 'IN_PROGRESS').length;
        const confirmedPassengers = passengersRes.data.data.filter(p => p.status === 'CONFIRMED').length;
        return {
            totalGroups: activeGroups,
            totalPassengers: confirmedPassengers,
            asistenciaHoy: 0,
            unreadNotifications: notifRes.data.unread,
        };
    },
    async getRecentGroups(tenantId, limit = 5) {
        const { data } = await apiClient.get('/api/v1/groups', {
            params: { page: 1, pageSize: limit, sortBy: 'departureDate', sortOrder: 'DESC' },
        });
        return data.data;
    },
    async getRecentPassengers(tenantId, limit = 5) {
        const { data } = await apiClient.get('/api/v1/passengers', {
            params: { page: 1, pageSize: limit },
        });
        return data.data;
    },
    async getUnreadNotifications(tenantId, limit = 5) {
        const { data } = await apiClient.get('/api/v1/notifications', {
            params: { page: 1, pageSize: limit },
        });
        return data.data;
    },
};
//# sourceMappingURL=dashboard.js.map